import { helpers } from 'vuelidate/lib/validators';

const hexColorRegex = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export default {
    hexColor: value => !helpers.req(value) || hexColorRegex.test(value),
};
